import { createSelector } from "@ngrx/store";
import { AppState } from "src/app/app.state";
import { IFilterProfile } from "src/app/interfaces/tankProfile";

const _selectFilterProfile = (state: AppState) => state.currentFilterProfile;
const _selectFilterModel = (state: AppState) => (state.currentFilterProfile && state.currentFilterProfile.tankFilterJson ? state.currentFilterProfile.tankFilterJson : null)

export const selectFilterProfile = createSelector(_selectFilterProfile, (state: IFilterProfile) => state)
export const selectFilterModelJson = createSelector(_selectFilterModel,(state: string) => state);

const _selectFilteredTanks = (state: AppState) => state.filteredTanks;
export const selectFilteredTanks = createSelector(_selectFilteredTanks,(state: any[]) => state);